import { View } from 'react-native';
import { Props } from 'shared/@types';
import { H1 } from 'shared/components/title';
import { useTranslation } from 'react-i18next';
import { ReviewsSummaryCard } from 'shared/components/reviews-summary-card';
import { ReviewCard } from 'shared/components/review-card';
import { buyerReviews } from 'shared/library/reviews';
import { Button } from 'shared/components/button';
import { useRoute } from 'shared/library/routes/route';

interface TestimonialsScreenProps extends Props {}

const TestimonialsScreen = ({}: TestimonialsScreenProps) => {
  const { t } = useTranslation('screens');
  const route = useRoute();

  return (
    <View className={'p-3 md:p-6 md:py-12'}>
      <View className={`mx-auto w-full max-w-screen-xl`}>
        <View
          className={
            'bg-brand-cream border-brand-green mb-3 self-center rounded-lg border-2 md:mb-6'
          }
        >
          <ReviewsSummaryCard />
        </View>

        <H1
          title={t('testimonials.title')}
          subtitle={t('testimonials.description')}
          center={true}
        />

        <View className={'mx-auto mt-3 w-full max-w-screen-md gap-3 md:mt-6 md:gap-6'}>
          {buyerReviews.map((review, index) => (
            <ReviewCard review={review} key={index} />
          ))}
        </View>

        <ReviewsSummaryCard className={'mt-6'} />

        <View className={'mt-6 flex-row flex-wrap justify-center gap-3'}>
          <Button
            text={t('web:layout.footer.sections.dogs.buying_a_dog')}
            href={route('buying-a-dog')}
            color={'brown'}
          />
          <Button
            text={t('web:layout.footer.sections.cats.buying_a_cat')}
            href={route('buying-a-cat')}
            color={'brown'}
          />
        </View>
      </View>
    </View>
  );
};

export { TestimonialsScreen };
export type { TestimonialsScreenProps };
